<div
	*ngIf="condoCorp$ | async as condoCorp; else search"
	class="flex flex-col gap-1"
>
	<div class="flex gap-2">
		<label>{{ label }}</label>
		<app-icon
			*ngIf="showAiIcon$ | async"
			[icon]="AI_GENERATED_ICON.icon"
			[classes]="AI_GENERATED_ICON.classes"
			[matTooltip]="AI_GENERATED_ICON.tooltip"
		/>
	</div>
	<app-firm-card
		[name]="condoCorp?.name"
		[phone]="condoCorp?.phoneNumber"
		[fax]="condoCorp?.faxNumber"
		[address]="condoCorpAddressString$ | async"
		[email]="condoCorp?.email"
		[cardType]="firmCardType$ | async"
		member="Condo Corporation"
		memberType="Business"
		(dropdown)="condoCorpDropdownEvent($event, condoCorp)"
	/>
</div>

<ng-template #search>
	<app-search-condo-corporation-input
		[label]="label"
		(onCreate)="onCreateCondoCorporation($event)"
		(onSelect)="onSelectCondoCorporation($event)"
	/>
</ng-template>
